import './home-wallet.scss';

import Warning from "../../../../assets/images/icons/caution.png";

import React, { FunctionComponent } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../features';
import { getRefreshToken } from '../../../../store/EncryptionSlice';
import { setModalSignInUp } from "../../../../store/AppSlice";
import { modalTypeEnum } from "../../../../types/modal";

export const HomeCardAccountInfo: FunctionComponent = () => {

    const dispatch = useAppDispatch()

    const checkLocal    = localStorage.getItem('encryptRt');
    const rtToken       = useAppSelector(getRefreshToken);

    const startLogin = () => {
        dispatch(setModalSignInUp(modalTypeEnum.deviceLogin));
    }

    const handleClickWallet = (cat: modalTypeEnum) => {
        if (cat === modalTypeEnum.deviceLogin) dispatch(setModalSignInUp(modalTypeEnum.deviceLogin));
        // temporário: registro em manutenção — voltar para modalTypeEnum.register quando o cadastro reabrir
        if (cat === modalTypeEnum.register) dispatch(setModalSignInUp(modalTypeEnum.register));
    }

    return (
        <>
            { (!rtToken && checkLocal) &&
                <p className="wallet-cta" onClick={startLogin}>
                    <span>
                        <img src={Warning} alt="" />
                        Sessão bloqueada! Coloque a senha do aparelho.
                    </span>
                    <button type="button" tabIndex={-1}>Desbloquear</button>
                </p>
            }
            { (!rtToken && !checkLocal) &&
                <p className="wallet-cta" onClick={() => handleClickWallet(modalTypeEnum.register)}>
                    <span>
                        <img src={Warning} alt="" />
                        Configure a sua carteira.
                    </span>
                    <button type="button" tabIndex={-1}>Configurar</button>
                </p>
            }
        </>
    )
}
